import { handleResponse, handleError } from "./apiUtils.js";
import { generateClient } from 'aws-amplify/api';
import dayjs from 'dayjs';
import * as queries from '../graphql/queries.js';
import * as mutations from '../graphql/mutations.js';
import getOffsetTime from '../utils/getOffsetTime.js';
import demoParams from '../__test__/demoParams.js';
import _ from 'underscore';
import { client } from "webpack-dev-server/bin/cli-flags.js";

const gclient = generateClient();

const {
    demoMode,
    demoDayTypeCalendarResourceId,
    demoDayTypeCalendarShowFutureDays,
    demoDayTypeCalendarUserId
} = demoParams;

/**
 * Returns an array of day types for the user over the next 365 days
 * @param {*} resourceId
 * @param {*} year - current year
 * @param {*} month - current month
 * @param {*} showFutureDays - from user.securityLevels
 * @param {*} userId
 */

export async function getDayTypeCalendar(resourceId, year, month, showFutureDays, userId) {

    let response = await gclient.graphql(
        {
            query: queries.dayTypeApIgetDayTypeCalendar,
            variables: {
                resourceId: demoMode ? demoDayTypeCalendarResourceId : resourceId,
                year,
                month,
                showFutureDays: demoMode ? demoDayTypeCalendarShowFutureDays : showFutureDays,
                userId: demoMode ? demoDayTypeCalendarUserId : userId
            }
        }
    );
    return response.data.dayTypeAPIgetDayTypeCalendar;
}


export async function getDayTypeSecurity(userId, dayTypeId) {
    let dayTypeSecurity = await gclient.graphql(
        {
            query: queries.dayTypeApIgetDayTypeSecurity,
            variables: {
                userId: demoMode ? demoDayTypeCalendarUserId : userId,
                dayTypeId
            }
        }
    );

    return dayTypeSecurity.data.dayTypeAPIgetDayTypeSecurity;
}

export async function createDayType(parameters) {

    parameters.ipAddress = '27.0.0.1';

    let response = await gclient.graphql(
        {
            query: mutations.dayTypeApIcreateDayTypeRequests, 
            variables: parameters
        }
    )
        .catch(handleError);

    return response.data.dayTypeAPIcreateDayTypeRequests;
}

export async function updateDayType(parameters) {

    parameters.ipAddress = '27.0.0.1';

    let response = await gclient.graphql(
        {
            query: mutations.dayTypeApIupdateDayTypeRequests, 
            variables: parameters
        }
    )
        .catch(handleError);

    return response.data.dayTypeAPIupdateDayTypeRequests;
}

export async function deleteDayType(parameters) {

    parameters.ipAddress = '27.0.0.1';

    let response = await gclient.graphql(
        {
            query: mutations.dayTypeApIdeleteDayTypeRequests, 
            variables: parameters
        }
    )
        .catch(handleError);

    return response.data.dayTypeApIdeleteDayTypeRequests;
}


export async function createResourceDayType(parameters) {

    parameters.IPAddress = '27.0.0.1';

    let response = await gclient.graphql(
        {
            query: mutations.dayTypeApIcreateResourceDayType, 
            variables: parameters
        }
    )
        .catch(handleError);

    return response.data.dayTypeAPIcreateResourceDayType;
}

export async function updateResourceDayType(parameters) {

    parameters.IPAddress = '27.0.0.1';
    console.log('parameters', parameters);

    let response = await gclient.graphql(
        {
            query: mutations.dayTypeApIupdateResourceDayType, 
            variables: parameters
        }
    )
        .catch(handleError);

    return response.data.dayTypeAPIupdateResourceDayType;
}

export async function updateResourceDayTypeComment(parameters) {

    parameters.IPAddress = '27.0.0.1';
    console.log('parameters', parameters);

    let response = await gclient.graphql(
        {
            query: mutations.dayTypeApIupdateResourceDayTypeComment, 
            variables: parameters
        }
    )
        .catch(handleError);

    return response.data.dayTypeAPIupdateResourceDayTypeComment;
}

export async function getDayTypeRequestsByYear(resourceId, year, month) {
    let showInRequest = false;

    let getDayTypeRequestsByYearPlusOne = await gclient.graphql(
        {
            query: queries.dayTypeApIgetDayTypeRequestsByYear,
            variables: {
                resourceId,
                showInRequest,
                year: year + 1,
                month: 1
            }
        }
    );

    let getDayTypeRequestsByYear = await gclient.graphql(
        {
            query: queries.dayTypeApIgetDayTypeRequestsByYear,
            variables: {
                resourceId,
                showInRequest,
                year,
                month: 1
            }
        }
    );

    let getDayTypeRequestsByYearMinusOne = await gclient.graphql(
        {
            query: queries.dayTypeApIgetDayTypeRequestsByYear,
            variables: {
                resourceId,
                showInRequest,
                year: year - 1,
                month: 1
            }
        }
    );

    let combinedArray = getDayTypeRequestsByYearPlusOne.data.dayTypeAPIgetDayTypeRequestsByYear.dayTypeRequests.reverse()
        .concat(getDayTypeRequestsByYear.data.dayTypeAPIgetDayTypeRequestsByYear.dayTypeRequests.reverse(),
            getDayTypeRequestsByYearMinusOne.data.dayTypeAPIgetDayTypeRequestsByYear.dayTypeRequests.reverse());
    let dayTypeRequestsArray = await addOffsetToTimes(combinedArray,true);

    let dayTypeRequests = {
        resourceId,
        year,
        dayTypeRequestsArray 
    }
    return dayTypeRequests;
}

export async function getResourceDayTypeByDate(resourceId, date) {
    let response = await gclient.graphql(
        {
            query: queries.dayTypeApIgetResourceDayTypeByDate, 
            variables: { resourceId, date }
        }
    )
        .catch(handleError);

    console.log('data', response.data.dayTypeAPIgetResourceDayTypeByDate)


    return response.data.dayTypeAPIgetResourceDayTypeByDate;
}

export async function getResourceDayTypeById(resourceDayTypeId) {
    let response = await gclient.graphql(
        {
            query: queries.dayTypeApIgetResourceDayTypeById, 
            variables: resourceDayTypeId
        }
    )
        .catch(handleError);

    let resourceDayType = response.data.dayTypeAPIgetResourceDayTypeById;
    let resourceDayTypeOffset = await addOffsetToTimes(resourceDayType.data);
    resourceDayType.data = resourceDayTypeOffset;
    return resourceDayType;
}

export async function getDayTypesAll(isApprover, resourceId, date, userId) {
    let response = await gclient.graphql(
        {
            query: queries.dayTypeApIgetDayTypesAll, 
            variables: { isApprover, resourceId, date, withForceTour: true, userId: userId }
        }
    )
        .catch(handleError);

    return response.data.dayTypeAPIgetDayTypesAll;
}

export async function getDayTypesAllWithoutForceTour(params) {
    let response = await gclient.graphql(
        {
            query: queries.dayTypeApIgetDayTypesAll, 
            variables: params
        }
    )
        .catch(handleError);

    return response.data.dayTypeAPIgetDayTypesAll;
}

export async function deleteResourceDayTypes(resourceId, fromDate, toDate, userId) {
    const IPAddress = '27.0.0.1';
    let response = await gclient.graphql(
        {
            query: mutations.dayTypeApIdeleteResourceDayTypes, 
            variables: { resourceId, fromDate, toDate, userId, IPAddress }
        }
    )
        .catch(handleError);

    return response.data.dayTypeAPIdeleteResourceDayTypes;
}

export async function deleteResourceDayType(parameters) {
    parameters.IPAddress = '27.0.0.1';
    let response = await gclient.graphql(
        {
            query: mutations.dayTypeApIdeleteResourceDayType, 
            variables: parameters
        }
    )
        .catch(handleError);

    return response.data.dayTypeAPIdeleteResourceDayType;
}

export async function getDayTypeRequestById(parameters) {
    let getDayTypeRequestById = await gclient.graphql(
        {
            query: queries.dayTypeApIgetDayTypeRequestById, 
            variables: parameters
        }
    )
        .catch(handleError);

    let dayTypeRequest = getDayTypeRequestById.data.dayTypeAPIgetDayTypeRequestById.dayTypeRequests;
    let dayTypeRequestOffset = await addOffsetToTimes(dayTypeRequest);
    return dayTypeRequestOffset;
}

export async function getDayTypesByDayRule(parameters) {
    let response = await gclient.graphql(
        {
            query: queries.dayTypeApIgetDayTypesByResourceDayRule, 
            variables: parameters
        }
    )
        .catch(handleError);
    return response.data.dayTypeAPIgetDayTypesByResourceDayRule;
}

export async function getDayTypesAllowingTourScheduling(parameters) {
    let response = await gclient.graphql(
        {
            query: queries.dayTypeApIgetDayTypesAllowingTourScheduling, 
            variables: parameters
        }
    )
        .catch(handleError);
    return response.data.dayTypeAPIgetDayTypesAllowingTourScheduling;
}

export async function getHasHolidays(parameters) {

    let response = await gclient.graphql(
        {
            query: queries.dayTypeApIgetHasHolidays, 
            variables: parameters
        }
    )
        .catch(handleError);

    return response.data.dayTypeAPIgetHasHolidays;
}

const addOffsetToTimes = async (array, avoidChange) => {
    let arrayCopy = [];

    array.forEach((dayType, index) => {
        let dayTypeCopy = { ...dayType }

        arrayCopy[index] = dayTypeCopy;
        

        if (arrayCopy[index].date) {
            if (avoidChange) {
                arrayCopy[index].date = arrayCopy[index].date.replace("Z","");
                return;
            }
            let dateOffset = getOffsetTime(dayjs(dayTypeCopy.date));
            arrayCopy[index].date = dayjs(dayTypeCopy.date).add(dateOffset, 'minute').format();
        }
        if (arrayCopy[index].fromDate) {
            if (avoidChange) {
                arrayCopy[index].fromDate = arrayCopy[index].fromDate.replace("Z","");  
                return;  
            }
            let fromDateOffset = getOffsetTime(dayjs(dayTypeCopy.fromDate));
            arrayCopy[index].fromDate = dayjs(dayTypeCopy.fromDate).add(fromDateOffset, 'minute').format();
        }
        if (arrayCopy[index].toDate) {
            if (avoidChange) {
                arrayCopy[index].toDate = arrayCopy[index].toDate.replace("Z","");  
                return;  
            }
            let toDateOffset = getOffsetTime(dayjs(dayTypeCopy.toDate));
            arrayCopy[index].toDate = dayjs(dayTypeCopy.toDate).add(toDateOffset, 'minute').format();
        }
        if (arrayCopy[index].fromTime) {
            if (avoidChange) {
                arrayCopy[index].fromTime = arrayCopy[index].fromTime.replace("Z","");  
                return;  
            }
            let fromTimeOffset = getOffsetTime(dayjs(arrayCopy[index].fromTime));
            arrayCopy[index].fromTime = dayjs(dayTypeCopy.fromTime).add(fromTimeOffset, 'minute').format();
        }
        if (arrayCopy[index].toTime) {
            if (avoidChange) {
                arrayCopy[index].toTime = arrayCopy[index].toTime.replace("Z","");  
                return;  
            }
            let toTimeOffset = getOffsetTime(dayjs(arrayCopy[index].toTime));
            arrayCopy[index].toTime = dayjs(dayTypeCopy.toTime).add(toTimeOffset, 'minute').format();
        }
    });

    return arrayCopy;
}
